import { render, staticRenderFns } from "./Captaindata.vue?vue&type=template&id=11733d1c&scoped=true&"
import script from "./Captaindata.vue?vue&type=script&lang=js&"
export * from "./Captaindata.vue?vue&type=script&lang=js&"
import style0 from "./Captaindata.vue?vue&type=style&index=0&id=11733d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11733d1c",
  null
  
)

export default component.exports